import React from "react";
import { DealerDetailsContextProvider } from "./DealerDetailsView";
import DealerDetails from "./views/DealerDetails";

const DealerDetailsPage = () => {
  return (
    <DealerDetailsContextProvider>
      <DealerDetails />
    </DealerDetailsContextProvider>
  );
};

export default DealerDetailsPage;
